import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=44c2b98e"
import script from "./form-wrapper.vue?vue&type=script&lang=js"
export * from "./form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c2b98e')) {
      api.createRecord('44c2b98e', component.options)
    } else {
      api.reload('44c2b98e', component.options)
    }
    module.hot.accept("./form-wrapper.vue?vue&type=template&id=44c2b98e", function () {
      api.rerender('44c2b98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list-update/form-wrapper.vue"
export default component.exports